import React, { useCallback, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  DialogActions,
  Stack,
  Typography,
} from "@mui/material";
import { TextField, MenuItem } from "@material-ui/core";
import { Button } from "rsuite";
import { Upload } from "../../../../../components/upload";
import { allowedMediaTypes, constants } from "../../../../../utils/common";
import { useFormik } from "formik";
import * as yup from "yup";
import { TextFieldComponent, TextFieldSelect } from "../../../../../components";

const StatusModal = ({
  isOpen,
  onClose,
  updateClickHandler,
  mtoPatchLoading,
  canChangeTo = [],
}) => {
  const yupObject = {
    status: yup.string("Select a status").required("Status is required."),

    remarks: yup.string("Write a remark").required("Remarks is required."),
    document: yup.mixed().when("status", {
      is: (value) => value === 3,
      then: yup
        .mixed()
        .required("Document image is required.")
        .test("fileExists", "Document image is required.", (value) => {
          return value instanceof File || (value && value.name); // works for FileList or File
        }),
    }),
  };

  const validationSchema = yup.object().shape(yupObject);

  const formik = useFormik({
    initialValues: {},
    validateOnBlur: true,
    validationSchema: validationSchema,
    validateOnMount: true,
    // validateOnChange: true,
  });

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      const newFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });

      if (file) {
        // setDoc(newFile);
        formik.setFieldValue("document", newFile);
      }
    },
    [formik]
  );
  const handleRemoveFile = () => {
    // setDoc(null);
    formik.setFieldValue("document", null);
  };

  const selectedStatusId = formik.values.status;

  const selectedStatusValue = canChangeTo.find(
    (status) => status.id === selectedStatusId
  )?.value;

  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth={"sm"}
      onClose={onClose}
      scroll={"body"}
      BackdropProps={{ style: { backgroundColor: "rgba(11, 5, 35, 0.8)" } }}
      PaperProps={{
        style: {
          boxShadow: "none",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }}>Update Status</DialogTitle>
      <DialogContent sx={{ paddingBottom: "0 !important" }}>
        <Box
          sx={{
            display: "grid",
            columnGap: 2,
            rowGap: 2,
            gridTemplateColumns: { xs: "repeat(1, 1fr)" },
          }}
        >
          <TextFieldSelect
            formik={formik}
            name="status"
            type="text"
            label="Status"
            options={canChangeTo}
            render={(item) => (
              <MenuItem value={item.id}>{item.actionable_name}</MenuItem>
            )}
          />
          {selectedStatusValue === constants.payoutDone && (
            <Stack
              direction={"column"}
              sx={{
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flex: 1,
              }}
              spacing={0.5}
            >
              <Typography>Upload Document *</Typography>
              <Upload
                accept={allowedMediaTypes}
                name="document"
                maxSize={5242880}
                onDrop={handleDrop}
                onDelete={handleRemoveFile}
                file={formik.values.document}
                error={
                  formik.touched.document && Boolean(formik.errors.document)
                }
                helperText={formik.touched.document && formik.errors.document}
              />
            </Stack>
          )}

          <TextFieldComponent
            multiline
            rows={3}
            formik={formik}
            name={"remarks"}
            label={"Remarks *"}
            type={"text"}
            required={false}
          />
        </Box>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button
            className="btn white-btn action-button "
            onClick={onClose}
            appearance="subtle"
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              updateClickHandler(
                formik.values.status,
                formik.values.remarks,
                formik.values.document
              )
            }
            loading={mtoPatchLoading}
            disabled={!formik.isValid}
            className={`btn action-button primary_color text-white`}
            appearance="primary"
          >
            Next
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default StatusModal;
